import axios from "axios";
import Qs from "qs";
import MyLocalStorage from "./MyLocalStorage";

// 创建axios实例
const request = axios.create({
  timeout: 15000, // 请求超时时间
  transformRequest: function(data) {
    return Qs.stringify(data);
  }
});
// 配置默认值
request.defaults.baseURL = process.env.VUE_APP_API_URL;
request.defaults.method = "post";
request.defaults.withCredentials = true;
// request拦截器
request.interceptors.request.use(
  config => {
    if (config.method === "post") {
      config.headers["Content-Type"] = "application/x-www-form-urlencoded"; // post请求
    }

    config.params = $.extend(
      {
        access_token: MyLocalStorage.getAccessToken(),
        client_from: 0,
        key: "UHIWXW3EP34V4S07E89IENQM0YGIHMTM",
        lang: "en-US",
        timestamp: new Date().getTime()
      },
      config.params
    );

    config.data = $.extend(
      {
        client_id: "YZ3L80B0ZNAMLQ8QU5GM8P3IE4B0KOG8"
      },
      config.data
    );

    return config;
  },
  error => {
    // Do something with request error
    console.log("Request:" + error); // for debug
    Promise.reject(error);
  }
);

// response 拦截器
request.interceptors.response.use(
  response => {
    const res = response.data;
    if (res.code !== 200) {
      // 正常错误
    }
    return response.data;
  },
  error => {
    console.log("Response:" + error.message); // for debug
    return Promise.reject(error);
  }
);

export default request;
